/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable simple-import-sort/imports */
/* eslint-disable prettier/prettier */
import { showGuideScreen, showMainSettingsScreen } from '../../screens/screens.reducers';

export const onKeyBackInfoScreen = () => (dispatch: Function) => {
    dispatch(showMainSettingsScreen());
};


export const onKeyGuideInfoScreen = () => (dispatch: Function) => {
    dispatch(showGuideScreen());
};
